import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { cooColumns, fetchCooRows } from "../../datatablesource"; // Assuming cooColumns is an array of column definitions
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";

const COODataTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const rows = await fetchCooRows(); // Assuming this fetches the data
        console.log("jawad", rows);

        // Check if rows.data exists and is not empty
        if (rows && rows.data && Array.isArray(rows.data)) {
          setData(rows.data);
        } else {
          // Set an empty array if no data is returned
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setData([]); // Ensure data is set to an empty array if fetch fails
      }
      setLoading(false);
    };
    getData();
  }, []);

  const handleDelete = (id) => {
    fetch(`${serverUrl}/del_user/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete COO");
        }
        setData((prevData) => prevData.filter((item) => item.id !== id));
        toast.success("COO deleted successfully!");
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
        toast.error("Failed to delete COO. Please try again.");
      });
  };

  const viewLinkString = "Coo-Single";
  const editLinkString = "Coo-Edit";
  const newLinkString = "Coo-New";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/coo/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/coo/update-coo/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2 lg:pb-2">
        <div className="text-gray-700 text-2xl">Chief Operating Officer</div>
        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          {slugs && slugs.includes(newLinkString) && (
            <Link to="/coo/new" className="commonButton w-full sm:w-auto">
              Add New
            </Link>
          )}
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={cooColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar,
          }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default COODataTable;
